import React, { useState, useEffect } from 'react';
import { Col, Container, Row, Label, Input, Form } from 'reactstrap';
import './Checkout.css';
import Header from '../components/Header';
import MenuHeader from '../components/MenuHeader';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '../components/Footer';

const Checkout = () => {
	const [products, setProducts] = useState([]);
	const [total, setTotal] = useState(0);
	const [overAllTotal, setOverAllTotal] = useState(0);
	const [formData, setFormData] = useState({});
	const history = useHistory();
	const handleChange = ({ target: { name, value } }) => {
		setFormData({ ...formData, hasChanged: true, [name]: value });
	};

	const handleSubmit = async e => {
		e.preventDefault();
		console.log(formData);
		await axios
			.post('https://zeroscan-backend.herokuapp.com/emailSend', {
				billingInfo: formData,
				products,
				total: overAllTotal,
			})
			.then(res => {
				console.log(res.data);
				localStorage.removeItem('checkout');
				localStorage.removeItem('cart');
				toast.success('Order Created Successfully');
				history.push('/');
			});
	};

	useEffect(() => {
		const allProducts = JSON.parse(localStorage.getItem('checkout'));
		if (allProducts) {
			setProducts(allProducts.products);
			setTotal(allProducts.total);
			setOverAllTotal(allProducts.total);
		} else {
			history.push('/shop');
		}
	}, []);
	return (
		<>
			<Header />
			<MenuHeader />
			<div className='container-fluid col-11 mt-4 mx-auto'>
				<h3 className='checkout_title'>Checkout</h3>
				<p className='checkout_text'>
					Finalize Your{' '}
					<strong className='checkout_text2'>Shopping</strong>
				</p>
				<p className='checkout_text'>
					Have a coupon?{' '}
					<strong className='checkout_text2'>
						Click here to enter your code
					</strong>
				</p>
			</div>
			<Form onSubmit={handleSubmit}>
				<div className='container-fluid'>
					<Container>
						<Row>
							<Col sm='8'>
								<h3 className='checkout_title mt-3'>
									Billing details
								</h3>
								<Row>
									<Col>
										<label className='checkout_label'>
											First name *
										</label>
									</Col>
									<Col>
										<label className='checkout_label'>
											Last name *
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='firstName'
											required
											onChange={handleChange}
										/>
									</Col>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='lastName'
											required
											onChange={handleChange}
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Email address *
										</label>
									</Col>
									<Col>
										<label className='checkout_label'>
											Mobile *
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='email'
											name='email'
											required
											onChange={handleChange}
										/>
									</Col>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='mobile'
											required
											onChange={handleChange}
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Company name ( Optional )
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='companyName'
											onChange={handleChange}
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Address line 1 *
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='Address1'
											required
											onChange={handleChange}
											placeholder='House Number And Street Name'
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Address line 2
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='Address2'
											onChange={handleChange}
											placeholder='House Number And Street Name'
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Town / City *
										</label>
									</Col>
									<Col>
										<label className='checkout_label'>
											Postcode *
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='town'
											required
											onChange={handleChange}
										/>
									</Col>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='postcode'
											required
											onChange={handleChange}
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Country *
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='country'
											required
											onChange={handleChange}
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Region / state *
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='region'
											onChange={handleChange}
											required
										/>
									</Col>
								</Row>
								<Row>
									<Col>
										<label className='checkout_label'>
											Order notes ( Optional )
										</label>
									</Col>
								</Row>
								<Row>
									<Col>
										<input
											className='checkout_input'
											type='text'
											name='orderNotes'
											onChange={handleChange}
										/>
									</Col>
								</Row>
							</Col>
							<Col sm='4' className='order_div'>
								<h3 className='checkout_title'>Your order</h3>
								<Row className='mt-4'>
									<Col>
										<div className='div_text'>Product</div>
									</Col>
									<Col>
										<div className='subTotal_title'>
											Subtotal
										</div>
									</Col>
								</Row>
								{products.map(product => (
									<Row className='mt-4'>
										<Col>
											<div className='product_title'>
												{product.name} x {product.value}
											</div>
										</Col>
										<Col>
											<div className='product_price'>
												${product.price * product.value}
											</div>
										</Col>
									</Row>
								))}

								<Row className='mt-4'>
									<Col>
										<div className='div_text'>Subtotal</div>
									</Col>
									<Col>
										<div className='product_price'>
											${total}
										</div>
									</Col>
								</Row>
								<Row className='mt-4'>
									<Col>
										<div className='div_text mt-3'>
											Shipping
										</div>
									</Col>
									<Col>
										<Label check className='product_price2'>
											<Input
												type='checkbox'
												className='mt-2'
												onChange={e => {
													if (e.target.checked) {
														setOverAllTotal(
															total + 10
														);
													} else {
														setOverAllTotal(
															overAllTotal - 10
														);
													}
												}}
											/>{' '}
											Shipping Charges: $10.00
										</Label>
										{/* <Label check className='product_price2'>
											<Input
												type='checkbox'
												className='mt-2'
											/>{' '}
											Shipping Charges: $10.00
										</Label> */}
									</Col>
								</Row>
								<Row className='mt-4'>
									<Col>
										<div className='div_text'>Total</div>
									</Col>
									<Col>
										<div className='product_price'>
											${overAllTotal}
										</div>
									</Col>
								</Row>
								<Row className='mt-4'>
									<p className='payment_line'>
										Please Select a Suitable Payment Method
										Below.
									</p>
								</Row>
								<Row className='ml--1'>
									<Label
										check
										className='product_price ml--2'
									>
										<Input
											type='checkbox'
											className='mt-2'
										/>{' '}
										PayPal
									</Label>
								</Row>
								<Row>
									<Label check className='product_price mx-5'>
										<Input
											type='checkbox'
											className='mt-2'
										/>{' '}
										Bank ( Credit / Debit ) Card
									</Label>
								</Row>
								<Row>
									<Label check className='product_price mx-5'>
										<Input
											type='checkbox'
											className='mt-2'
										/>{' '}
										Cash-On-Delivery
									</Label>
								</Row>
								<Row>
									<Label check className='product_price mx-4'>
										<Input
											type='checkbox'
											className='mt-2'
											required
										/>{' '}
										I have read and agree to the website
										terms and conditions *
									</Label>
								</Row>
								<Row className='mt-4'>
									<button
										type='submit'
										className='payment_btn mx-3'
									>
										Place Order
									</button>
								</Row>
							</Col>
						</Row>
					</Container>
				</div>
			</Form>
			<Footer />
		</>
	);
};

export default Checkout;
